import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { Amplify } from 'aws-amplify';
import { environment } from './environments/environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.amplify.Auth.userPoolId,
      userPoolClientId: environment.amplify.Auth.userPoolClientId,
      loginWith: {
        oauth: {
          domain: environment.amplify.Auth.cognitoDomain,
          scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [window.location.origin + '/login'],
          redirectSignOut: [window.location.origin + '/login'],
          responseType: 'code'
        }
      }
    }
  },

});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
